module.exports = __webpack_public_path__ + "img/user_icon_on.59f5daaa.svg";